module.exports = __webpack_public_path__ + "img/page_info_fail.a47a00a.svg";